import {AfterViewInit, Component, EventEmitter, Input, NgZone, Output, ViewChild} from '@angular/core';
import {AbstractNgModelComponent} from '../ng-model.component';
import {IonSegment, SegmentChangeEventDetail} from '@ionic/angular';

@Component({template: ''})
// @ts-ignore
export abstract class IonSegmentBaseComponent extends AbstractNgModelComponent<number | string> implements IonSegment, AfterViewInit {

  @ViewChild('ionSegment', {static: false}) ionSegmentElement;

  @Input() color?: any;
  @Input() mode: 'ios' | 'md' = 'ios';
  @Input() swipeGesture?: boolean = false;
  counterChecked: any[] = [];

  // ionSegmentButton props:
  @Input() layout?: 'icon-bottom' | 'icon-end' | 'icon-hide' | 'icon-start' | 'icon-top' | 'label-hide' | undefined = 'icon-top';
  @Input() type?: 'button' | 'reset' | 'submit' = 'button';

  @Output() ionChange: EventEmitter<CustomEvent<SegmentChangeEventDetail>> = new EventEmitter();

  protected el: HTMLElement;
  protected z: NgZone;

  onChange(event: CustomEvent<SegmentChangeEventDetail> | any) {
    if(this.counterChecked?.length) {
      this.counterChecked = this.counterChecked.map((item) => false);
    }
    this.counterChecked[parseInt(event.detail.value,10)] = true;
    // this.value = event.detail.value;
    // эмиттить не нужно, эмит происходит где-то в другом месте
    // this.ionChange.emit(event);
    // console.log('IonSegmentBaseComponent onChange event', event);
  }

  ngAfterViewInit() {
    if(this.counterChecked?.length) {
      this.counterChecked = this.counterChecked.map((item) => false);
    }
    this.counterChecked[parseInt(this.value?.toString(), 10)] = true;
  }
}
